export enum ITaskExportField {
  id = 'id',
  TaskName = 'taskName',
  Description = 'description',
  ProjectName = 'projectName',
  AssignedBy = 'assignedBy',
  AssignedOn = 'assignedOn',
  DueDate = 'dueDate',
  EndTime = 'endTime',
  Label = 'label',
  Status = 'status',
}

export enum IFilterOption {
  Assignee = 'assignee',
  Date = 'date',
}
